import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Popup, genericTexts, Loader, SortableTable, RadioGroup } from 'hub-web-lib'
import { ACTIVITY } from 'js/constants/vocabulary'
import { ACTIVITY_PATH, PEN_TEST, PEN_TEST_MODULE, appModulesPaths } from 'js/constants/app-modules'
import { connect } from 'react-redux'
import { action } from 'js/actions'
import { UPDATE_NOTIFICATION_CONTENT } from 'js/constants/action-types'
import store from 'js/store'
import PenTestApi from 'services/PenTestApi'
import { penTestActivityColumns } from 'js/constants/table-columns'
import { UpdatePenTestActivity } from './UpdateActivity/UpdatePenTestActivity'
import 'scss/UpdateActivity/UpdateActivity.scss'
import UserApi from 'services/UserApi'
import { penTestTypes } from 'js/constants/enums/pen-test'
import { getUserRole } from 'js/ui-helpers/roles'
import { getActivityTableData, getSelectedActivity } from 'js/ui-helpers/activity'
import { nonCompleteNotification, allOption, allTypes, ARCHIVED, starArchive } from 'js/constants/enums/activity'
import { ACTIVE } from 'js/constants/metrics/common-metrics'
import 'scss/ActivityManagement.scss'
import { refactorFindings } from 'js/ui-helpers/metrics'

const mapStateToProps = state => {
    return {
        currentUser: state.currentUser,
        currentUserOrgs: state.currentUserOrgs
    }
}

export const PenTestActivityManagementComponent = ({ currentUser, currentUserOrgs }) => {
    const currentOrgId = currentUser?.current_org
    const [isLoading, setIsLoading] = useState(true)
    const [activities, setActivities] = useState([])
    const [selectedActivityId, setSelectedActivityId] = useState('')
    const [isOpenActivityPopup, setIsOpenActivityPopup] = useState(false)
    const [isNewActivity, setIsNewActivity] = useState(false)
    const [isOpenDeletePopup, setIsOpenDeletePopup] = useState(false)
    const [currentOrg, setCurrentOrg] = useState(null)
    const [orgUsers, setOrgUsers] = useState([])
    const [templateUrl, setTemplateUrl] = useState('')
    const [starArray, setStarArray] = useState()
    const [findingsUrl, setFindingsUrl] = useState('')
    const [testType, setTestType] = useState('all_types')
    const [isShowArchived, setIsShowArchived] = useState(false)
    const [filterType, setFilterType] = useState('all')
    const [searchParams] = useSearchParams()
    const providedId = searchParams.get('id')
    const { selectedActivity, selectedActivityTitle } = getSelectedActivity(activities, selectedActivityId)
    const activityColumnsUser = currentUser?.is_admin ? penTestActivityColumns : [...penTestActivityColumns].filter(c => c.key !== 'organization')
    const navigate = useNavigate()

    const openUpdateActivityPopup = () => {
        setIsNewActivity(true)
        setIsOpenActivityPopup(true)
    }

    const closeUpdateActivityPopup = () => {
        setIsNewActivity(false)
        setIsOpenActivityPopup(false)
        setSelectedActivityId('')
    }

    const updateActivityStatus = async (activityId, actionType) => {
        const currentActivity = await PenTestApi.getActivity(activityId)
        if (!currentActivity || currentActivity.error) {
            store.dispatch(action(UPDATE_NOTIFICATION_CONTENT, { message: currentActivity.message, notificationType: 'error' }))
            return
        }
        currentActivity[actionType] = !currentActivity[actionType]
        const updated_activity = await PenTestApi.updateActivity(currentActivity)
        if (!updated_activity || updated_activity.error) {
            store.dispatch(action(UPDATE_NOTIFICATION_CONTENT, { message: updated_activity.message, notificationType: 'error' }))
            return
        }
    
        await updateActivities()
    }  

    const filterTableData = () => {
        if (isShowArchived) return tableData.filter(item => item.archived)
        const biggerFilter = tableData.filter(item => (filterType === allOption.id ? true : item.starred) && !item.archived)
        if (testType === 'all_types') return biggerFilter
        return biggerFilter.filter(item => item.test_type === testType)
  
    }


    const getTableData = () => {
        const data = getActivityTableData(activities, starArray)
            .map(a => ({
                ...a,
                testType: penTestTypes.find(t => t.id === a.test_type)?.name || '-'
            }))
        return data
    }

    const updateActivities = async () => {
        const activities = await PenTestApi.getAllActivities(currentOrgId)
        if (!activities || activities.error) {
            store.dispatch(action(UPDATE_NOTIFICATION_CONTENT, { message: activities.message, notificationType: 'error' }))
            return
        }
        for await (const activity of activities) {
            activity.metrics = []
            const metrics = await PenTestApi.getActivityMetrics(activity.id)
            if (metrics && !metrics.error) activity.metrics = metrics
            activity.findings = []
            if (activity.has_findings) {
                const findings = await PenTestApi.getActivityFindings(activity.id)
                if (findings && !findings.error) activity.findings = refactorFindings(findings)
            }
        }
        setActivities(activities)
        const tempStarArray = {}
        activities.map(a => tempStarArray[a.id] = a.starred)
        setStarArray(tempStarArray) 

    }

    const getPermittedUsersList = (users) => {
        return [...users.filter(user => getUserRole(user) < 4)
            .sort((a, b) => a.id * 1 - b.id * 1)
            .map(user => ({ id: user.id, name: user.name || user.user_name }))]
    }

    const getOrgsAndMetrics = async () => {
        const org = currentUserOrgs.find(o => o.id === currentOrgId) || { id: currentOrgId }
        const users = await UserApi.getOrgUsers(currentOrgId)
        setCurrentOrg(org && !org.error ? org : { id: currentOrgId })
        setOrgUsers(users && !users.error ? getPermittedUsersList(users) : [])
    }

    const getTemplateUrl = async () => {
        const template = await PenTestApi.downloadMetricsTemplate()
        const findings = await PenTestApi.downloadFindingsTemplate()
        setTemplateUrl(template?.url || '')
        setFindingsUrl(findings?.url || '')
    }

    const deleteActivity = async () => {
        setIsOpenDeletePopup(false)
        const deletedActiviry = await PenTestApi.deleteActivity(selectedActivityId)
        if (!deletedActiviry || deletedActiviry.error) {
            store.dispatch(action(UPDATE_NOTIFICATION_CONTENT, { message: genericTexts.defaultText.deletedError(ACTIVITY), notificationType: 'error' }))
            return
        }  
        store.dispatch(action(UPDATE_NOTIFICATION_CONTENT, { message: genericTexts.defaultText.deletedSuccess(ACTIVITY) }))
        await updateActivities()
    }

    const menuClickHandler = async (action, activityId) => {
        setSelectedActivityId(activityId)
        const { selectedActivity } = getSelectedActivity(activities, activityId)
        switch (action) {
        case genericTexts.actionsText.info:
            navigate(`/${appModulesPaths[PEN_TEST_MODULE]}/${ACTIVITY_PATH}/${activityId}`, { state: { activity: selectedActivity } })
            break
        case genericTexts.actionsText.edit:
            setIsOpenActivityPopup(true)
            setIsNewActivity(false)
            break
        case genericTexts.actionsText.archive:
            updateActivityStatus(activityId, 'archived')
            break
        case genericTexts.actionsText.delete:
            setIsOpenDeletePopup(true)
            break
        }
    }

    const openEditPopup = () => {
        if (!providedId) return
        const { selectedActivity } = getSelectedActivity(activities, providedId)
        if (selectedActivity) {
            if (!selectedActivity.is_complete) store.dispatch(action(UPDATE_NOTIFICATION_CONTENT, { message: nonCompleteNotification, notificationType: 'warning' }))
            setSelectedActivityId(providedId)
            setIsOpenActivityPopup(true)
            setIsNewActivity(false)
        }
    }

    const handleTdClick = (val, activityId) => {
        if (val === 'star') {
            const updatedStarArray = { ...starArray } 
            updatedStarArray[activityId] = !updatedStarArray[activityId] 
            setStarArray(updatedStarArray)
            updateActivityStatus(activityId, 'starred')
            return
        }
        setSelectedActivityId(activityId)
        setIsOpenActivityPopup(true)
        setIsNewActivity(false)
    }
    const tableData = getTableData()
    const filteredTableData = filterTableData()
    useEffect( async () => {
        await getOrgsAndMetrics()
        await updateActivities()
        openEditPopup()
        setIsLoading(false)
        getTemplateUrl()
    }, [])

    return (
        <div className='pen-test-activities page-content'>
            <div className='page-header'>
                <h1 id='pen-test-activities-management'>{PEN_TEST} Activities Management</h1>
                {!isLoading && <button onClick={openUpdateActivityPopup} id='add-new-pen-test-activity'>{genericTexts.defaultText.addNewButton(ACTIVITY)}</button>}
            </div>
            <div className='filter-buttons-div'>
                {!!tableData?.length && <div className={`filter-switcher ${filteredTableData.length ? 'has-content' : ''}`}>
                    {!isShowArchived && <RadioGroup radioGroupId='filter-switcher-group' checkedId={filterType} isSwitcher={true} updateItem={setFilterType} allItems={ [allOption, starArchive] }/>}
                    <div className='archive-button'> 
                        <button className='btn-set' onClick={() => setIsShowArchived(!isShowArchived)}>Show {isShowArchived ? ACTIVE : ARCHIVED}</button>
                    </div>
                </div>}
                {!!tableData?.length && <div className={`filter-switcher ${filteredTableData.length ? 'has-content' : ''}`}>
                    <RadioGroup radioGroupId='filter-switcher-group' checkedId={testType} isSwitcher={true} updateItem = { val => setTestType(val) } allItems={ [ allTypes, ...penTestTypes] }/>
                </div>}
            </div>

            {isLoading ? <Loader /> : <div className='report-management-con'>
                <SortableTable 
                    columns={activityColumnsUser}
                    tableData={filteredTableData}
                    defaultSort={{ key: 'id' }}
                    menuClickHandler={menuClickHandler}
                    handleTdClick={handleTdClick}
                    tableId='pen-test-activities-table' />
                {isOpenActivityPopup && <Popup
                    onClose={closeUpdateActivityPopup}
                    isOpen={isOpenActivityPopup}
                    title={isNewActivity ? genericTexts.defaultText.addNewPopupTitle(ACTIVITY) : genericTexts.actionsText.editText(ACTIVITY, true)}
                    isDisabledClickOutside={true}
                    customClass='update-activity update-activity-pen-test'>
                    <UpdatePenTestActivity
                        isNewActivity={isNewActivity}
                        currentOrg={currentOrg}
                        orgUsers={orgUsers}
                        currentUser={currentUser}
                        closeUpdateActivityPopup={closeUpdateActivityPopup}
                        updateActivities={updateActivities}
                        activityDetails={selectedActivity}
                        templateUrl={templateUrl}
                        findingsUrl={findingsUrl} />
                </Popup>}


            </div>}
            <Popup
                onClose={() => setIsOpenDeletePopup(false)}
                isOpen={isOpenDeletePopup}
                title={genericTexts.defaultText.deletePopupTitle}>
                <p>{genericTexts.defaultText.deletePopupText(`${ACTIVITY} ${selectedActivityTitle}`)}</p>
                <div className='popup-buttons'>
                    <button className='btn-submit' onClick={deleteActivity} id='delete-pen-test-activity'>{genericTexts.defaultText.yes}</button>
                    <button onClick={() => setIsOpenDeletePopup(false)} className='btn-cancel' id='delete-pen-test-activity-cancel'>{genericTexts.defaultText.no}</button>
                </div>
            </Popup>
        </div>     
    )
}

const PenTestActivityManagement = connect(mapStateToProps)(PenTestActivityManagementComponent)

export default PenTestActivityManagement